export default __webpack_public_path__ + "static/media/Commander's Haversack.77c0822d.jpg";